<div class="table-container">
  <div class="table-title">
    <div class="title-section">
      <div class="title-accent"></div>
      <h1>{{ title }}</h1>
    </div>
    <div class="search-section" *ngIf="showSearch">
      <div class="search-toolbar" [class.search-right]="searchRight">
        <div class="search-container">
          <i class="fas fa-search search-icon"></i>
          <input
            type="text"
            class="search-input"
            [(ngModel)]="searchTerm"
            (input)="onSearchChange()"
            [placeholder]="searchPlaceholder">
          <button
            type="button"
            class="search-clear-btn"
            *ngIf="searchTerm"
            (click)="clearSearch()"
            aria-label="Limpar busca">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>
        <button type="button" class="filter-btn" title="Filtros">
          <i class="fa-solid fa-filter"></i>
        </button>
      </div>
    </div>
    <div class="header-actions">
      <ng-content select="[table-header-action]"></ng-content>
    </div>
  </div>
  
  <div class="table-wrapper" [class.loading]="loading">
    <!-- Overlay de carregamento -->
    <div class="table-loading-overlay" *ngIf="loading">
      <div class="table-loading-spinner"></div>
      <p class="table-loading-text">Carregando dados...</p>
    </div>
    <table>
      <thead class="table-header">
        <tr>
          <th *ngFor="let column of columns; let i = index" 
              class="resizable-column"
              [attr.data-column]="i"
              (click)="onSort(column)">
            <span class="header-content" [class.sortable]="isColumnSortable(column)">
              <span class="header-title">
                {{ column.titulo }}
                <button
                  *ngIf="column.sensitive"
                  type="button"
                  class="btn-sensitive-eye header-sensitive-eye"
                  (click)="toggleSensitiveColumn($event, column)"
                  [attr.aria-label]="isSensitiveColumnRevealed(column) ? 'Ocultar valores da coluna' : 'Visualizar valores da coluna'"
                  [title]="isSensitiveColumnRevealed(column) ? 'Ocultar valores' : 'Visualizar valores'">
                  <i class="fas" [ngClass]="isSensitiveColumnRevealed(column) ? 'fa-eye-slash' : 'fa-eye'" aria-hidden="true"></i>
                </button>
              </span>
              <span class="sort-icons" *ngIf="isColumnSortable(column)">
                <!-- Ícone único: neutro, asc ou desc -->
                <i 
                  class="fas"
                  [ngClass]="{
                    'fa-arrow-up': isSortedAsc(column),
                    'fa-arrow-down': isSortedDesc(column),
                    'fa-arrows-up-down': !isSortedAsc(column) && !isSortedDesc(column),
                    'active': isSortedAsc(column) || isSortedDesc(column)
                  }">
                </i>
              </span>
            </span>
            <div class="resize-handle" 
                 (mousedown)="startResize($event, i)"
                 *ngIf="i < columns.length - 1"></div>
          </th>
          <th *ngIf="hasAnyActions()" 
              class="actions-column" 
              [style.width]="getActionsColumnWidth()"
              [style.min-width]="getActionsColumnWidth()"
              [style.max-width]="getActionsColumnWidth()"
              aria-label="Ações">
            <span class="header-title">Ações</span>
          </th>
        </tr>
      </thead>
      <tbody class="table-body">
        <!-- Estado vazio quando não há dados (não exibir enquanto loading) -->
        <tr *ngIf="!loading && paginatedData.length === 0" class="empty-row">
          <td [attr.colspan]="columns.length + (hasAnyActions() ? 1 : 0)" class="empty-cell">
            <div class="table-empty">
              <i class="fas fa-inbox"></i>
              <h3>Nenhum resultado encontrado</h3>
              <p>Tente ajustar os filtros ou a busca para encontrar o que procura.</p>
            </div>
          </td>
        </tr>
        
        <!-- Dados da tabela -->
        <tr *ngFor="let item of paginatedData; let rowIndex = index" 
            (click)="onRowClick(item)" 
            [style.cursor]="clickable ? 'pointer' : 'default'"
            [class.no-hover]="hoverDisabledRowId === getItemId(item)">
          <td *ngFor="let column of columns" [ngClass]="getCellClass(item[column.label], item, column)">
            <ng-container *ngIf="column.sensitive; else plainCell">
              <span class="sensitive-cell-value">
                {{ isSensitiveColumnRevealed(column) ? formatDisplayValue(item[column.label], column) : '****' }}
              </span>
            </ng-container>
            <ng-template #plainCell>{{ formatDisplayValue(item[column.label], column) }}</ng-template>
          </td>
          <td *ngIf="hasActionsForItem(item)" 
              class="actions-cell"
              [style.width]="getActionsColumnWidth()"
              [style.min-width]="getActionsColumnWidth()"
              [style.max-width]="getActionsColumnWidth()"
              (click)="$event.stopPropagation()"
              (mouseenter)="onActionsCellMouseEnter(getItemId(item)); $event.stopPropagation()"
              (mouseleave)="onActionsCellMouseLeave(); $event.stopPropagation()">
            
            <!-- Botões Visíveis (sempre aparecem) -->
            <div *ngIf="getVisibleActionsForItem(item).length > 0" class="action-buttons">
              <button 
                *ngFor="let action of getVisibleActionsForItem(item)" 
                class="btn btn-action"
                [ngClass]="getActionClasses(action)"
                [disabled]="action.disabled"
                (click)="onActionClick(action.action, item); $event.stopPropagation()"
                [title]="action.label">
                <i [class]="getActionIcon(action)"></i>
              </button>
            </div>

            <!-- Menu Dropdown (quando há ações no dropdown) -->
            <div *ngIf="getDropdownActionsForItem(item).length > 0" class="actions-menu-container" [class.open-up]="shouldOpenMenuUp(rowIndex)">
              <button 
                class="btn-menu-trigger"
                (click)="toggleMenu(getItemId(item), $event); $event.stopPropagation()"
                [class.active]="openMenuId === getItemId(item)"
                title="Mais opções">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </button>
              
              <div 
                class="actions-dropdown"
                *ngIf="openMenuId === getItemId(item)"
                (click)="$event.stopPropagation()">
                <button 
                  *ngFor="let action of getDropdownActionsForItem(item)"
                  [ngClass]="getDropdownItemClasses(action)"
                  [disabled]="action.disabled"
                  (click)="onActionClick(action.action, item); closeMenu(); $event.stopPropagation()"
                  [title]="action.label"
                  [attr.aria-label]="action.label">
                  <i *ngIf="!action.divider" [class]="getActionIcon(action)"></i>
                  <span *ngIf="!action.divider">{{ action.label }}</span>
                </button>
              </div>
            </div>

            <!-- Botões Padrão (quando não usa dropdown nem tem ações visíveis separadas) -->
            <div *ngIf="!shouldUseDropdown && getVisibleActionsForItem(item).length === 0 && actions.length > 0" class="action-buttons">
              <button 
                *ngFor="let action of actions" 
                class="btn btn-action"
                [ngClass]="getActionClasses(action)"
                [disabled]="action.disabled"
                (click)="onActionClick(action.action, item); $event.stopPropagation()"
                [title]="action.label">
                <i [class]="getActionIcon(action)"></i>
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Paginação (apenas se não estiver desabilitada) -->
  <div class="pagination-container" *ngIf="!disablePagination">
    <div class="pagination-info">
      <span>Mostrando {{ startItem }} a {{ endItem }} de {{ totalItems }} Itens</span>
    </div>
    
    <div class="pagination-controls">
      <div class="items-per-page">
        <label for="itemsPerPage">Itens por página:</label>
        <select 
          id="itemsPerPage" 
          [(ngModel)]="itemsPerPage" 
          (change)="onItemsPerPageChange()">
          <option *ngFor="let option of itemsPerPageOptions" [value]="option">
            {{ option }}
          </option>
        </select>
      </div>
      
      <div class="pagination-buttons">
        <button 
          class="btn btn-prev" 
          (click)="goToPreviousPage()" 
          [disabled]="isFirstPage">
          <i class="fas fa-chevron-left"></i>
          Anterior
        </button>
        
        <button 
          class="btn btn-next" 
          (click)="goToNextPage()" 
          [disabled]="isLastPage">
          Próxima
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  </div>
</div>

